module.exports = __webpack_public_path__ + "img/etfhome_78672.png";